<template>
	<transition type="animation" appear enter-active-class="animate__animated animate__fadeIn" mode="out-in">
		<div v-if="temPermissao('segmento-fundamental-i')" class="main pb-4" id="about-main">
			<b-container fluid="lg">
				<b-card no-body class="p-4 shadow-sm card__sistemacpv p-4">
					<b-nav class="nav-books" tabs fill>
						<b-nav-item @click="setActive(index)" :active="activeIndex === index" v-for="(menu, index) in lists"
							:key="index">
							<i :class="menu.iconClass"></i>
							<span class="mr-auto">{{ menu.name }}</span>
						</b-nav-item>
					</b-nav>
					<div v-for="(menu, index) in lists" :key="index">
						<b-collapse @show="setActive(index)" @hide="clearActive(index)" :visible="activeIndex === index">
							<div class="mt-3" v-if="menu.turmas">
								<b-card no-body v-for="(turma, idx) in menu.turmas" :key="idx" class="mt-2 border-light shadow-none">
									<template #header>
										<div @click="toggleCollapse('colecaoCpv', idx)" class="button-toggle p-3"
											v-if="menu.name == 'Coleção CPV'">
											<div class="d-flex align-items-center justify-content-baseline">
												<i :class="turma.iconClass" style="color: #3A1C53;"></i>
												<span class="mr-auto"><strong>{{ turma.name }}</strong> <span v-if="turma.otherName != ''">- ({{
													turma.otherName }})</span></span>
												<i :class="collapsedStates.colecaoCpv[idx] ? 'fa-solid fa-minus' : 'fa-solid fa-plus'"></i>
											</div>
										</div>
										<div @click="toggleCollapse('simuladoCpv', idx)" class="button-toggle p-3"
											v-if="menu.name == 'Simulados'">
											<div class="d-flex align-items-center justify-content-baseline">
												<span class="mr-auto"><strong>{{ turma.name }}</strong> <span v-if="turma.otherName != ''">- ({{
													turma.otherName }})</span></span>
												<i :class="collapsedStates.simuladoCpv[idx] ? 'fa-solid fa-minus' : 'fa-solid fa-plus'"></i>
											</div>
										</div>
										<div @click="toggleCollapse('manualCpv', idx)" class="button-toggle p-3"
											v-if="menu.name == 'Manual'">
											<div class="d-flex align-items-center justify-content-baseline">
												<span class="mr-auto"><strong>{{ turma.name }}</strong> <span v-if="turma.otherName != ''">- ({{
													turma.otherName }})</span></span>
												<i :class="collapsedStates.manualCpv[idx] ? 'fa-solid fa-minus' : 'fa-solid fa-plus'"></i>
											</div>
										</div>
										<div @click="toggleCollapse('musicaCpv', idx)" class="button-toggle p-3"
											v-if="menu.name == 'Músicas'">
											<div class="d-flex align-items-center justify-content-baseline">
												<span class="mr-auto"><strong>{{ turma.name }}</strong> <span v-if="turma.otherName != ''">- ({{
													turma.otherName }})</span></span>
												<i :class="collapsedStates.musicaCpv[idx] ? 'fa-solid fa-minus' : 'fa-solid fa-plus'"></i>
											</div>
										</div>
									</template>
									<b-collapse v-model="collapsedStates.colecaoCpv[idx]" v-if="menu.name == 'Coleção CPV'">
										<div class="p-3">
											<b-row>
												<b-col cols="12" v-for="(book, idx) in turma.books" :key="idx" class="mt-2">
													<router-link :to="{
														name: 'render-conteudo-exclusivo',
														params: { paramsForUrl: book.linkFree || '', nomeApostila: book.name || '' },
														query: { material: formatParam(book.description) }
													}">
														<b-card no-body class="p-3 text-dark">
															<div class="d-flex aling-items-center">
																<i :class="book.iconClass" class="d-flex align-items-center"></i>
																<span>{{ book.name }}</span>
															</div>
														</b-card>
													</router-link>
												</b-col>
											</b-row>
										</div>
									</b-collapse>
									<b-collapse v-model="collapsedStates.simuladoCpv[idx]" v-if="menu.name == 'Simulados'">
										<div class="p-3">
											<b-row>
												<b-col cols="12" v-for="(book, idx) in turma.books" :key="idx" class="mt-2">
													<router-link :to="{
														name: 'render-conteudo-exclusivo',
														params: { paramsForUrl: book.linkFree || '', nomeApostila: book.name || '' },
														query: { material: formatParam(book.description) }
													}">
														<b-card no-body class="p-3 text-dark">
															<div class="d-flex aling-items-center">
																<i :class="book.iconClass" class="d-flex align-items-center"></i>
																<span>{{ book.name }}</span>
															</div>
														</b-card>
													</router-link>
												</b-col>
											</b-row>
										</div>
									</b-collapse>
									<b-collapse v-model="collapsedStates.manualCpv[idx]" v-if="menu.name == 'Manual'">
										<div class="p-3">
											<b-row>
												<b-col cols="12" v-for="(book, idx) in turma.books" :key="idx" class="mt-2">
													<router-link :to="{
														name: 'render-conteudo-exclusivo',
														params: { paramsForUrl: book.linkFree || '', nomeApostila: book.name || '' },
														query: { material: formatParam(book.description) }
													}">
														<b-card no-body class="p-3 text-dark">
															<div class="d-flex aling-items-center">
																<i :class="book.iconClass" class="d-flex align-items-center"></i>
																<span>{{ book.name }}</span>
															</div>
														</b-card>
													</router-link>
												</b-col>
											</b-row>
										</div>
									</b-collapse>
									<b-collapse v-model="collapsedStates.musicaCpv[idx]" v-if="menu.name == 'Músicas'">
										<div class="p-3">
											<b-row>
												<b-col cols="12" md="6" lg="4" v-for="(book, idx) in turma.books" :key="idx" class="mt-2">
													<b-link :href="book.linkUrl" alt="">
														<b-card no-body>
															<div class="p-3">
																<span class="font-weight-normal text-dark">{{ book.name }}</span>
																<div class="d-flex justify-content-baseline">
																	<span class="font-weight-bold text-dark small d-block mr-auto">{{ book.materia
																		}}</span>
																	<span class="font-weight-bold text-dark small">{{ book.ano_ensino }}</span>
																</div>
																<div class="d-flex justify-content-baseline">
																	<span class="font-weight-bold text-dark small mr-auto">{{ book.caderno }}</span>
																	<span class="font-weight-light text-dark d-block small">{{ book.pagina }}</span>
																</div>
															</div>
														</b-card>
													</b-link>
												</b-col>
											</b-row>
										</div>
									</b-collapse>
								</b-card>
								<div class="d-flex justify-content-center mt-3" v-if="menu.name == 'Músicas'">
									<b-link href="http://www.letras.com.br/musicas-infantis" class="btn btn_sistemacpv"
										variant="transparent" target="_blank">
										<span style="font-size: 14px">Confira outras sugestões.</span>
									</b-link>
								</div>
							</div>
							<div class="mt-3" v-else>
								<b-card no-body class="mt-2 border-0 shadow-none">
									<b-row>
										<b-col cols="12" v-for="(book, i) in menu.books" :key="i" class="mt-2">
											<router-link :to="{
												name: 'render-conteudo-exclusivo',
												params: { paramsForUrl: book.linkFree || '', nomeApostila: book.name || '' },
												query: { material: formatParam(book.description) }
											}">
												<b-card no-body class="p-3 text-dark">
													<div class="d-flex aling-items-center">
														<i :class="book.iconClass" class="d-flex align-items-center"></i>
														<span>{{ book.name }}</span>
													</div>
												</b-card>
											</router-link>
										</b-col>
									</b-row>
								</b-card>
							</div>
						</b-collapse>
					</div>
				</b-card>
			</b-container>
		</div>
		<div v-else>
			<div class="container">
				<div class="text-center">
					{{ error503 }}
					<p>Você não tem permissão para visualizar este conteúdo.</p>
				</div>

			</div>
		</div>
	</transition>
</template>

<script>
export default {
	name: 'dash-infantil',
	props: ['paramsForUrl', 'nomeApostila'],

	data() {
		return {
			pageTitle: 'ENSINO FUNDAMENTAL I',
			pageSubtitle: '',

			NamePermission: '',
			IndexPermission: '',

			activeIndex: 0,

			collapsedStates: {
				colecaoCpv: [],
				simuladoCpv: [],
				manualCpv: [],
				musicaCpv: [],
			},

			lists: [
				{
					id: 1,
					name: 'Coleção CPV',
					iconClass: 'fa-solid fa-book fa-sm mr-1',
					link_name: 'fundamental-1-caderno-digital',
					colorCard: {
						'background-color': '#38aaf3',
						'border:': '1px solid #38aaf3',
						'border-radius': '0.5rem',
					},
					permission: 'segmento-fundamental-i',
					bg__link: 'infantil',
					turmas: [
						{
							name: '1º Ano',
							otherName: '',
							permission: 'segmento-fundamental-i',
							books: [
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/colecao-cpv/1-ano/book_01_fun_01-web.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/base-fund1-cad-1.png',
									bundle: 'F_fundamental',
									name: '1º Ano - Caderno 1',
									segment: '1',
									discipline: '',
									description: '1º Ano - Caderno 1',
									toolTip: 'A Coleção é composta de dois Cadernos um por semestre, esse é o caderno 1',
									isbn: 'ISBN: 978-85-8451-012-2',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/colecao-cpv/1-ano/book_01_fun_02-pro.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/base-fund1-cad-2.png',
									bundle: 'F_fundamental',
									name: '1º Ano - Caderno 2',
									segment: '1',
									discipline: '',
									description: '1º Ano - Caderno 2',
									toolTip: 'A Coleção é composta de dois Cadernos um por semestre, esse é o caderno 2',
									isbn: 'ISBN: 978-85-8451-013-9',
								},

								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/colecao-cpv/1-ano/book_01_fun_03.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/base-fund1-cad-3.png',
									bundle: 'F_fundamental',
									name: '1º Ano - Caderno 3',
									segment: '1',
									discipline: '',
									description: '1º Ano - Caderno 3',
									toolTip: 'A Coleção é composta de dois Cadernos um por semestre, esse é o caderno 3',
									isbn: 'ISBN: 978-85-8451-014-6',
								},

								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/colecao-cpv/1-ano/book_01_fun_04.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/base-fund1-cad-4.png',
									bundle: 'F_fundamental',
									name: '1º Ano - Caderno 4',
									segment: '1',
									discipline: '',
									description: '1º Ano - Caderno  4',
									toolTip: 'A Coleção é composta de dois Cadernos um por semestre, esse é o caderno 4',
									isbn: 'ISBN: 978-85-8451-015-3',
								},
							]
						},
						{
							name: '2º Ano',
							otherName: '',
							permission: 'segmento-fundamental-i',
							books: [
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/colecao-cpv/2-ano/book_02_fun_01-web.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/base-fund1-2-cad-1.png',
									bundle: 'F_fundamental',
									name: '2º Ano - Caderno 1',
									segment: '2',
									discipline: '',
									description: '2º Ano - Caderno 1',
									toolTip: '',
									isbn: 'Barcode: EFU-0006',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/colecao-cpv/2-ano/book_02_fun_02.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/base-fund1-2-cad-2.png',
									bundle: 'F_fundamental',
									name: '2º Ano - Caderno 2',
									segment: '2º Ano - Caderno 2',
									discipline: '',
									description: '2º Ano - Caderno 2',
									toolTip: '',
									isbn: 'ISBN: 978-85-8451-017-7',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/colecao-cpv/2-ano/book_02_fun_03.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/base-fund1-2-cad-3.png',
									bundle: 'F_fundamental',
									name: '2º Ano - Caderno 3',
									segment: '2',
									discipline: '',
									description: '2º Ano - Caderno 3',
									toolTip: '',
									isbn: 'ISBN: 978-85-8451-018-4',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/colecao-cpv/2-ano/book_02_fun_04.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/base-fund1-2-cad-4.png',
									bundle: 'F_fundamental',
									name: '2º Ano - Caderno 4',
									segment: '2',
									discipline: '',
									description: '2º Ano - Caderno 4',
									toolTip: '',
									isbn: 'ISBN: 978-85-8451-019-1',
								},
							]
						},
						{
							name: '3º Ano',
							otherName: '',
							permission: 'segmento-fundamental-i',
							books: [
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/colecao-cpv/3-ano/book_03_fun_01-web.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/base-fund1-3-cad-1.png',
									bundle: 'F_fundamental',
									name: '3º Ano - Caderno 1',
									segment: '3',
									discipline: '',
									description: '3º Ano - Caderno 1',
									toolTip: '',
									isbn: 'Barcode: EFU-0006',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/colecao-cpv/3-ano/book_03_fun_02.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/base-fund1-3-cad-2.png',
									bundle: 'F_fundamental',
									name: '3º Ano - Caderno 2',
									segment: '3',
									discipline: '',
									description: '3º Ano - Caderno 2',
									toolTip: '',
									isbn: 'ISBN: 978-85-8451-017-7',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/colecao-cpv/3-ano/book_03_fun_03.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/base-fund1-3-cad-3.png',
									bundle: 'F_fundamental',
									name: '3º Ano - Caderno 3',
									segment: '3',
									discipline: '',
									description: '3º Ano - Caderno 3',
									toolTip: '',
									isbn: 'ISBN: 978-85-8451-018-4',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/colecao-cpv/3-ano/book_03_fun_04.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/base-fund1-3-cad-4.png',
									bundle: 'F_fundamental',
									name: '3º Ano - Caderno 4',
									segment: '3',
									discipline: '',
									description: '3º Ano - Caderno 4',
									toolTip: '',
									isbn: 'ISBN: 978-85-8451-019-1',
								},
							]
						},
						{
							name: '4º Ano',
							otherName: '',
							permission: 'segmento-fundamental-i',
							books: [
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/colecao-cpv/4-ano/book_04_fun_01-web.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/base-fund1-4-cad-1.png',
									bundle: 'F_fundamental',
									name: '4º Ano - Caderno 1',
									segment: '4',
									discipline: '',
									description: '4º Ano - Caderno 1',
									toolTip: '',
									isbn: 'ISBN:  EFU1-0014',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/colecao-cpv/4-ano/book_04_fun_02.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/base-fund1-4-cad-2.png',
									bundle: 'F_fundamental',
									name: '4º Ano - Caderno 2',
									segment: '4',
									discipline: '',
									description: '4º Ano - Caderno 2',
									toolTip: '',
									isbn: 'ISBN: 978-85-8451-025-2',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/colecao-cpv/4-ano/book_04_fun_03.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/base-fund1-4-cad-3.png',
									bundle: 'F_fundamental',
									name: '4º Ano - Caderno 3',
									segment: '4',
									discipline: '',
									description: '4º Ano - Caderno 3',
									toolTip: '',
									isbn: 'ISBN: 978-85-8451-026-9',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/colecao-cpv/4-ano/book_04_fun_04.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/base-fund1-4-cad-4.png',
									bundle: 'F_fundamental',
									name: '4º Ano - Caderno 4',
									segment: '4',
									discipline: '',
									description: '4º Ano - Caderno 4',
									toolTip: '',
									isbn: 'ISBN: 978-85-8451-027-6',
								},
							]
						},
						{
							name: '5º Ano',
							otherName: '',
							permission: 'segmento-fundamental-i',
							books: [
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/colecao-cpv/5-ano/book_05_fun_01-web.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/base-fund1-5-cad-1.png',
									bundle: 'F_fundamental',
									name: '5º Ano - Caderno 1',
									segment: '5',
									discipline: '',
									description: '5º Ano - Caderno 1',
									toolTip: '',
									isbn: 'ISBN:  ',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/colecao-cpv/5-ano/book_05_fun_02.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/base-fund1-5-cad-2.png',
									bundle: 'F_fundamental',
									name: '5º Ano - Caderno 2',
									segment: '5',
									discipline: '',
									description: '5º Ano - Caderno 2',
									toolTip: '',
									isbn: 'ISBN: 978-85-8451-029-0 ',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/colecao-cpv/5-ano/book_05_fun_03.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/base-fund1-5-cad-3.png',
									bundle: 'F_fundamental',
									name: '5º Ano - Caderno 3',
									segment: '5',
									discipline: '',
									description: '5º Ano - Caderno 3',
									toolTip: '',
									isbn: 'ISBN: 978-85-8451-030-6 ',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/colecao-cpv/5-ano/book_05_fun_04.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/base-fund1-5-cad-4.png',
									bundle: 'F_fundamental',
									name: '5º Ano - Caderno 4',
									segment: '5',
									discipline: '',
									description: '5º Ano - Caderno 4',
									toolTip: '',
									isbn: 'ISBN: 978-85-8451-031-3 ',
								},
							]
						},
					],
				},
				{
					id: 2,
					name: 'Simulados',
					iconClass: 'fa-solid fa-box-archive fa-sm mr-1',
					link_name: 'provas-simulados',
					colorCard: {
						'background-color': '#4ac8aa',
						'border:': '1px solid #4ac8aa',
						'border-radius': '0.5rem',
					},
					permission: 'segmento-fundamental-i',
					bg__link: 'fundamental-i',
					turmas: [
						{
							name: '2º Ano',
							otherName: '',
							permission: 'segmento-fundamental-i',
							books: [
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/simulados/2-ano/sim_ef-1_2o_ano_2o_bim.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/base-fund1-cad-1.png',
									bundle: 'F_fundamental',
									name: 'Simulado - 2º Ano - 2º Bimestre',
									material: 'Simulado_2o_Ano_Fundamental_I',
									segment: '1',
									discipline: '',
									description: 'Simulado - 2º Bimestre',
									toolTip: 'A Coleção é composta de dois Cadernos um por semestre, esse é o caderno 1',
									isbn: 'ISBN: 978-85-8451-012-2',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/simulados/2-ano/sim_ef-1_2o_ano_3o_bim.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/base-fund1-cad-2.png',
									bundle: 'F_fundamental',
									name: 'Simulado - 2º Ano - 3º Bimestre',
									segment: '1',
									discipline: '',
									description: 'Simulado - 2º Ano - 3º Bimestre',
									toolTip: 'A Coleção é composta de dois Cadernos um por semestre, esse é o caderno 2',
									isbn: 'ISBN: 978-85-8451-013-9',
								},
							]
						},
						{
							name: '3º Ano',
							otherName: '',
							permission: 'segmento-fundamental-i',
							books: [
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/simulados/3-ano/sim_ef-1_3o_ano_2o_bim.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/base-fund1-simulado-3.png',
									bundle: 'F_fundamental',
									name: 'Simulado - 3º Ano - 2º Bimestre',
									segment: '3',
									discipline: '',
									description: 'Coleção Didática CPV Ensino Fundamental',
									description2: 'Simulado – 3º Ano',
									toolTip: '',
									isbn: 'ISBN:  ',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/simulados/3-ano/sim_ef-1_3o_ano_3o_bim.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/sim_ef-1_3o_ano_3o_bim.png',
									bundle: 'F_fundamental',
									name: 'Simulado - 3º Ano - 3º Bimestre',
									segment: '3',
									discipline: '',
									description: 'Coleção Didática CPV Ensino Fundamental',
									description2: 'Simulado – 3º Ano – 3º Bimestre',
									toolTip: '',
									isbn: 'ISBN:  ',
								},
							]
						},
						{
							name: '4º Ano',
							otherName: '',
							permission: 'segmento-fundamental-i',
							books: [
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/simulados/4-ano/sim_ef-1_4o_ano_2o_bim.pdf',
									videoId: '',
									src: '',
									bundle: 'F_fundamental',
									name: 'Simulado - 4º Ano - 2º Bimestre',
									segment: '4',
									discipline: '',
									description: '4º Ano - Caderno 1',
									toolTip: '',
									isbn: 'ISBN:  EFU1-0014',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/simulados/4-ano/sim_ef-1_4o_ano_3o_bim.pdf',
									videoId: '',
									src: '',
									bundle: 'F_fundamental',
									name: 'Simulado - 4º Ano - 3º Bimestre',
									segment: '4',
									discipline: '',
									description: '4º Ano - Caderno 2',
									toolTip: '',
									isbn: 'ISBN: 978-85-8451-025-2',
								},
							]
						},
						{
							name: '5º Ano',
							otherName: '',
							permission: 'segmento-fundamental-i',
							books: [
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/simulados/5-ano/sim_ef-1_5o_ano_2o_bim.pdf',
									videoId: '',
									src: '',
									bundle: 'F_fundamental',
									name: 'Simulado - 5º Ano - 2º Bimestre',
									segment: '4',
									discipline: '',
									description: '4º Ano - Caderno 1',
									toolTip: '',
									isbn: 'ISBN:  EFU1-0014',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/simulados/5-ano/sim_ef-1_5o_ano_3o_bim.pdf',
									videoId: '',
									src: '',
									bundle: 'F_fundamental',
									name: 'Simulado - 5º Ano - 3º Bimestre',
									segment: '4',
									discipline: '',
									description: '4º Ano - Caderno 2',
									toolTip: '',
									isbn: 'ISBN: 978-85-8451-025-2',
								},
							]
						},
					]
				},
				{
					id: 3,
					name: 'Programação',
					iconClass: 'fa-solid fa-calendar-days fa-sm mr-1',
					link_name: 'programacao-ensino-fundamental-i',
					colorCard: {
						'background-color': '#a7dc48',
						'border:': '1px solid #a7dc48',
						'border-radius': '0.5rem',
					},
					permission: 'segmento-fundamental-i',
					bg__link: 'fundamental-ii',
					books: [
						{
							linkReaOnly: '',
							iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
							linkFree: 'ensino-fundamental-1/programacao/programacao-ensino-fundamental-I-2024.pdf',
							videoId: '',
							src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/base-fund1-programacao.png',
							bundle: 'F_fundamental',
							name: 'Proposta Pedagógica e Programação',
							segment: '1',
							discipline: '',
							description: 'Ensino Fundamental I - Proposta Pedagógica e Programação',
							toolTip: ' ',
							isbn: 'Programação ',
						},
					]
				},
				{
					id: 4,
					name: 'Manual',
					iconClass: 'fa-solid fa-notebook fa-sm mr-1',
					link_name: 'manual-ensino-fundamental-i',
					colorCard: {
						'background-color': '#fc5b5b',
						'border:': '1px solid #fc5b5b',
						'border-radius': '0.5rem',
					},
					permission: 'segmento-fundamental-i',
					bg__link: 'medio',
					turmas: [
						{
							name: '1º Ano',
							otherName: '',
							permission: 'segmento-fundamental-i',
							books: [
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/1-ano/manual-coodenador.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/base-fund1-manual-coordenador.png',
									bundle: 'F_FUND1',
									name: 'Manual de Orientações para Coordenadores',
									segment: '',
									discipline: '',
									description: 'Manual de Orientações para o Coordenador',
									toolTip: '',
									isbn: 'Manual',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/1-ano/Manual-Educacao-Fisica-EF1.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_manual_professor.png',
									bundle: 'F_FUND1',
									name: 'Manual de Orientações - Educação Física',
									segment: '1',
									discipline: 'Educação Física',
									description: 'Manual Educação Física – 1º Ano',
									toolTip: '',
									isbn: 'Manual',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/1-ano/cie1fun_manual_anual-web-1.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_manual_professor.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor – Ciências Naturais',
									segment: '1',
									discipline: 'Ciências',
									description: 'Ciências Naturais – 1º Ano',
									toolTip: '',
									isbn: 'Manual',
								},

								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/1-ano/geo1fun_manual_anual-web-1.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_manual_professor.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor – Geografia',
									segment: '1',
									discipline: 'Geografia',
									description: 'Geografia – 1º Ano',
									toolTip: '',
									isbn: 'Manual',
								},

								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/1-ano/his1fun_manual_anual-web-1.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_manual_professor.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor – História',
									segment: '1',
									discipline: 'História',
									description: 'História – 1º Ano',
									toolTip: '',
									isbn: 'Manual',
								},

								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/1-ano/art1fun_manual_anual-web-2.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_manual_professor.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor – História da Arte',
									segment: '1',
									discipline: 'História',
									description: 'História da Arte – 1º Ano',
									toolTip: '',
									isbn: 'Manual',
								},

								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/1-ano/ing1fun_manual_anual-web-1.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_manual_professor.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor – Inglês',
									segment: '1',
									discipline: 'Língua Inglesa',
									description: 'Inglês – 1º Ano',
									toolTip: '',
									isbn: 'Manual',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/1-ano/por1fun_manual_anual-web-1.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_manual_professor.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor – Língua Portuguesa',
									segment: '1',
									discipline: 'Língua Portuguesa',
									description: 'Língua Portuguesa – 1º Ano',
									toolTip: '',
									isbn: 'Manual',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/1-ano/mat1fun_manual_anual-web-1.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_manual_professor.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor – Matemática',
									segment: '1',
									discipline: 'Matemática',
									description: 'Matemática – 1º Ano',
									toolTip: '',
									isbn: 'Manual',
								},
							]
						},
						{
							name: '2º Ano',
							otherName: '',
							permission: 'segmento-fundamental-i',
							books: [
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/2-ano/manual-coodenador.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund2/base-fund1-manual-coordenador.png',
									bundle: 'F_FUND2',
									name: 'Manual de Orientações para Coordenador',
									segment: '',
									discipline: '',
									description: 'Manual de Orientações Coordenador',
									toolTip: '',
									isbn: 'Manual',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/2-ano/Manual-Educacao-Fisica-EF1.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_manual_professor.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor - Educação Física',
									segment: '1',
									discipline: 'Educação Física',
									description: 'Manual Educação Física 2º Ano',
									toolTip: '',
									isbn: 'Manual',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/2-ano/cie2fun_manual_anual-web-1.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor2.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor – Ciências Naturais',
									segment: '2',
									discipline: 'Ciências',
									description: 'Ciências Naturais 2º Ano',
									toolTip: '',
									isbn: 'Manual',
								},

								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/2-ano/geo2fun_manual_anual-web-1.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor2.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor – Geografia',
									segment: '2',
									discipline: 'Geografia',
									description: 'Caderno do Professor Geografia 2º Ano',
									toolTip: '',
									isbn: 'Manual',
								},

								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/2-ano/his2fun_manual_anual-web-1.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor2.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor – História',
									segment: '2',
									discipline: 'História',
									description: 'Caderno do Professor História 2º Ano',
									toolTip: '',
									isbn: 'Manual',
								},

								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/2-ano/art2fun_manual_anual-web-2.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor2.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor – História da Arte',
									segment: '2',
									discipline: 'História',
									description: 'Caderno do Professor História da Arte 2º Ano',
									toolTip: '',
									isbn: 'Manual',
								},

								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/2-ano/ing2fun_manual_anual-web-1.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor2.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor – Inglês',
									segment: '2',
									discipline: 'Língua Inglesa',
									description: 'Caderno do Professor Inglês 2º Ano',
									toolTip: '',
									isbn: 'Manual',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/2-ano/por2fun_manual_anual-web-1.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor2.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor – Língua Portuguesa',
									segment: '2',
									discipline: 'Língua Portuguesa',
									description: 'Caderno do Professor Língua Portuguesa 2º Ano',
									toolTip: '',
									isbn: 'Manual',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/2-ano/mat2fun_manual_anual-web-1.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor2.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor – Matemática',
									segment: '2',
									discipline: 'Matemática',
									description: 'Caderno do Professor Matemática 2º Ano',
									toolTip: '',
									isbn: 'Manual',
								},
							]
						},
						{
							name: '3º Ano',
							otherName: '',
							permission: 'segmento-fundamental-i',
							books: [
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/3-ano/manual-coodenador.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/base-fund1-manual-coordenador.png',
									bundle: 'F_FUND1',
									name: 'Manual de Orientações para o Coordenador',
									segment: '',
									discipline: '',
									description: 'Manual de Orientações para o Coordenador',
									toolTip: '',
									isbn: 'Manual',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/3-ano/Manual-Educacao-Fisica-EF1.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_manual_professor.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor - Educação Física',
									segment: '1',
									discipline: 'Educação Física',
									description: 'Manual Educação Física – 1º Ano',
									toolTip: '',
									isbn: 'Manual',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/3-ano/cie3fun_manual_anual-web-2.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor_3.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor – Ciências Naturais',
									segment: '3',
									discipline: 'Ciências',
									description: 'Ciências Naturais – 3º Ano',
									toolTip: '',
									isbn: 'Manual',
								},

								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/3-ano/geo3fun_manual_anual-web-1.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor_3.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor – Geografia',
									segment: '3',
									discipline: 'Geografia',
									description: 'Geografia – 3º Ano',
									toolTip: '',
									isbn: 'Manual',
								},

								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/3-ano/his3fun_manual_anual-web-1.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor_3.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor – História',
									segment: '3',
									discipline: 'História',
									description: 'História – 3º Ano',
									toolTip: '',
									isbn: 'Manual',
								},

								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/3-ano/art3fun_manual_anual-web-2.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor_3.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor – História da Arte',
									segment: '3',
									discipline: 'História',
									description: 'História da Arte – 3º Ano',
									toolTip: '',
									isbn: 'Manual',
								},

								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/3-ano/ing3fun_manual_anual-web-1.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor_3.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor – Inglês',
									segment: '3',
									discipline: 'Língua Inglesa',
									description: 'Inglês – 3º Ano',
									toolTip: '',
									isbn: 'Manual',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/3-ano/por3fun_manual_anual-web-1.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor_3.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor – Língua Portuguesa',
									segment: '3',
									discipline: 'Língua Portuguesa',
									description: 'Língua Portuguesa – 3º Ano',
									toolTip: '',
									isbn: 'Manual',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/3-ano/mat3fun_manual_anual-web-1.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor_3.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor – Matemática',
									segment: '3',
									discipline: 'Matemática',
									description: 'Matemática – 3º Ano',
									toolTip: '',
									isbn: 'Manual',
								},

								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/3-ano/ing3fun01PORT.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor_3.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor - Inglês - 1º Bimestre',
									segment: '3',
									discipline: 'Tradução Inglês 3º ano ',
									description: '1º Bimestre',
									toolTip: '',
									isbn: 'Tradução',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/3-ano/ing3fun02PORT.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor_3.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor - Inglês - 2º Bimestre',
									segment: '3',
									discipline: 'Tradução Inglês 3º ano ',
									description: '2º Bimestre',
									toolTip: '',
									isbn: 'Tradução',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/3-ano/ing3fun03PORT.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor_3.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor - Inglês - 3º Bimestre',
									segment: '3',
									discipline: 'Tradução Inglês 3º ano ',
									description: '3º Bimestre',
									toolTip: '',
									isbn: 'Tradução',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/3-ano/ing3fun0413port.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor_3.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor - Inglês - 4º Bimestre',
									segment: '3',
									discipline: 'Tradução Inglês 3º ano ',
									description: '4º Bimestre',
									toolTip: '',
									isbn: 'Tradução',
								},
							]
						},
						{
							name: '4º Ano',
							otherName: '',
							permission: 'segmento-fundamental-ii',
							books: [
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/4-ano/manual-coodenador.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/base-fund1-manual-coordenador.png',
									bundle: 'F_FUND1',
									name: 'Manual de Orientações para o Coordenador',
									segment: '',
									discipline: '',
									description: 'Manual de Orientações para o Coordenador',
									toolTip: '',
									isbn: 'Manual',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/4-ano/Manual-Educacao-Fisica-EF1.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_manual_professor.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor - Educação Física',
									segment: '1',
									discipline: 'Educação Física',
									description: 'Manual Educação Física – 1º Ano',
									toolTip: '',
									isbn: 'Manual',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/4-ano/cie4fun_manual_anual-web-1.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor4.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor - Ciências Naturais',
									segment: '4',
									discipline: 'Ciências',
									description: 'Ciências Naturais – 4º Ano',
									toolTip: '',
									isbn: 'Manual',
								},

								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/4-ano/geo4fun_manual_anual-web-1.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor4.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor - Geografia',
									segment: '4',
									discipline: 'Geografia',
									description: 'Geografia – 4º Ano',
									toolTip: '',
									isbn: 'Manual',
								},

								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/4-ano/his4fun_manual_anual-web-2.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor4.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor - História',
									segment: '4',
									discipline: 'História',
									description: 'História – 4º Ano',
									toolTip: '',
									isbn: 'Manual',
								},

								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/4-ano/art4fun_manual_anual-web.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor4.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor - História da Arte',
									segment: '4',
									discipline: 'História',
									description: 'História da Arte – 4º Ano',
									toolTip: '',
									isbn: 'Manual',
								},

								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/4-ano/ing4fun_manual_anual-web-1.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor4.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor - Inglês',
									segment: '4',
									discipline: 'Língua Inglesa',
									description: 'Inglês – 4º Ano',
									toolTip: '',
									isbn: 'Manual',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/4-ano/por4fun_manual_anual-web-1.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor4.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor - Língua Portuguesa',
									segment: '4',
									discipline: 'Língua Portuguesa',
									description: 'Língua Portuguesa – 4º Ano',
									toolTip: '',
									isbn: 'Manual',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/4-ano/mat4fun_manual_anual-web-1.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor4.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor - Matemática',
									segment: '4',
									discipline: 'Matemática',
									description: 'Matemática – 4º Ano',
									toolTip: '',
									isbn: 'Manual',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/4-ano/ing4fun0113port.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor4.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor - Inglês - 1º Bimestre',
									segment: '4',
									discipline: 'Caderno do Professor ',
									description: '1º Bimestre',
									toolTip: '',
									isbn: 'Tradução',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/4-ano/ing4fun0214port.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor4.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor - Inglês - 2º Bimestre',
									segment: '4',
									discipline: 'Caderno do Professor',
									description: '2º Bimestre',
									toolTip: '',
									isbn: 'Tradução',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/4-ano/ing4fun0313port.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor4.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor - Inglês - 3º Bimestre',
									segment: '4',
									discipline: 'Caderno do Professor',
									description: '3º Bimestre',
									toolTip: '',
									isbn: 'Tradução',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/4-ano/ing4fun0413port.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor4.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor - Inglês - 4º Bimestre',
									segment: '4',
									discipline: 'Tradução Inglês 3º ano ',
									description: '4º Bimestre',
									toolTip: '',
									isbn: 'Tradução',
								},

							]
						},
						{
							name: '5º Ano',
							otherName: '',
							permission: 'segmento-fundamental-i',
							books: [
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/5-ano/manual-coodenador.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/base-fund1-manual-coordenador.png',
									bundle: 'F_FUND1',
									name: 'Manual de Orientações para o Coordenador',
									segment: '',
									discipline: '',
									description: 'Manual de Orientações para o Coordenador',
									toolTip: '',
									isbn: 'Manual',
								},

								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/5-ano/Manual-Educacao-Fisica-EF1.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_manual_professor.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor - Educação Física',
									segment: '1',
									discipline: 'Educação Física',
									description: 'Manual Educação Física – 1º Ano',
									toolTip: '',
									isbn: 'Manual',
								},

								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/5-ano/cie5fun_manual_anual-web-1.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor5.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor – Ciências Naturais',
									segment: '5',
									discipline: 'Ciências',
									description: 'Ciências Naturais – 5º Ano',
									toolTip: '',
									isbn: 'Manual',
								},

								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/5-ano/geo5fun_manual_anual-web-2.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor5.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor – Geografia',
									segment: '5',
									discipline: 'Geografia',
									description: 'Geografia – 5º Ano',
									toolTip: '',
									isbn: 'Manual',
								},

								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/5-ano/his5fun_manual_anual-web-2.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor5.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor – História',
									segment: '5',
									discipline: 'História',
									description: 'História – 5º Ano',
									toolTip: '',
									isbn: 'Manual',
								},

								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/5-ano/art5fun_manual_anual-web-2.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor5.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor – História da Arte',
									segment: '5',
									discipline: 'História',
									description: 'História da Arte – 5º Ano',
									toolTip: '',
									isbn: 'Manual',
								},

								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/5-ano/ing5fun_manual_anual-web-2.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor5.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor – Inglês',
									segment: '5',
									discipline: 'Língua Inglesa',
									description: 'Inglês – 5º Ano',
									toolTip: '',
									isbn: 'Manual',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/5-ano/por5fun_manual_anual-web-2.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor5.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor – Língua Portuguesa',
									segment: '5',
									discipline: 'Língua Portuguesa',
									description: 'Língua Portuguesa – 5º Ano',
									toolTip: '',
									isbn: 'Manual',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/5-ano/mat5fun_manual_anual-web-2.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor5.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor – Matemática',
									segment: '5',
									discipline: 'Matemática',
									description: 'Matemática – 5º Ano',
									toolTip: '',
									isbn: 'Manual',
								},

								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/5-ano/ing5fun0114port.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor5.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor - Inglês - 1º Bimestre',
									segment: '5',
									discipline: '',
									description: '1º Bimestre',
									toolTip: '',
									isbn: 'Tradução',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/5-ano/ing5fun0214port.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor5.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor - Inglês - 2º Bimestre',
									segment: '5',
									discipline: '',
									description: '2º Bimestre',
									toolTip: '',
									isbn: 'Tradução',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/5-ano/ing5fun0313port.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor5.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor - Inglês - 3º Bimestre',
									segment: '5',
									discipline: '',
									description: '3º Bimestre',
									toolTip: '',
									isbn: 'Tradução',
								},
								{
									linkReaOnly: '',
									iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
									linkFree: 'ensino-fundamental-1/manual/5-ano/ing5fun0414port.pdf',
									videoId: '',
									src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor5.png',
									bundle: 'F_FUND1',
									name: 'Caderno do Professor - Inglês - 4º Bimestre',
									segment: '5',
									discipline: 'Tradução Inglês 3º ano ',
									description: '5º Bimestre',
									toolTip: '',
									isbn: 'Tradução',
								},
							]
						},
					]
				},
				{
					id: 5,
					name: 'Músicas',
					iconClass: 'fa-solid fa-music fa-sm mr-1',
					link_name: 'ensino-fund1-musicas',
					colorCard: {
						'background-color': '#fa6d9e',
						'border:': '1px solid #fa6d9e',
						'border-radius': '0.5rem',
					},
					permission: 'segmento-fundamental-i',
					bg__link: 'pre-vestibular',
					turmas: [
						{
							name: '1º Bimestre',
							otherName: '',
							permission: 'segmento-infantil',
							books: [
								{
									name: 'As letras do alfabeto',
									materia: 'Língua Portuguesa',
									caderno: 'Cad. 1',
									ano_ensino: '1º Ano',
									pagina: 'P. 16',
									linkUrl: 'https://www.youtube.com/watch?v=Fx9tHZA7hNY',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'O Sapo não lava o pé',
									materia: 'Língua Portuguesa',
									caderno: 'Cad. 1',
									ano_ensino: '1º Ano',
									pagina: 'P. 27',
									linkUrl: 'https://www.youtube.com/watch?v=0JkSpPZJDkE',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Ursinho Pimpão',
									materia: 'Língua Portuguesa',
									caderno: 'Cad. 1',
									ano_ensino: '1º Ano',
									pagina: 'P. 53',
									linkUrl: 'https://www.youtube.com/watch?v=GOGO1guXyJsV',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'A canoa virou',
									materia: 'Língua Portuguesa',
									caderno: 'Cad. 1',
									ano_ensino: '1º Ano',
									pagina: 'P. 76',
									linkUrl: 'https://www.youtube.com/watch?v=3cDsvBPn-mQ',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Coelhinho',
									materia: 'Língua Portuguesa',
									caderno: 'Cad. 1',
									ano_ensino: '1º Ano',
									pagina: 'P. 84',
									linkUrl: 'https://www.youtube.com/watch?v=nS-yJupHhOc',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Nossa história',
									materia: 'História',
									caderno: 'Cad. 1',
									ano_ensino: '1º Ano',
									pagina: 'P. 104',
									linkUrl: 'https://www.youtube.com/watch?v=NM8kyPbulX0',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'A Casa',
									materia: 'Geografia',
									caderno: 'Cad. 1',
									ano_ensino: '1º Ano',
									pagina: 'P. 124',
									linkUrl: 'https://www.youtube.com/watch?v=wnkdc5NX0H0',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Quem tem medo do Lobo mau',
									materia: 'Geografia',
									caderno: 'Cad. 1',
									ano_ensino: '1º Ano',
									pagina: 'P. 134 e 135',
									linkUrl: 'https://www.youtube.com/watch?v=9qNqedZZaig',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Os Sentindos',
									materia: 'Ciências Naturais',
									caderno: 'Cad. 1',
									ano_ensino: '1º Ano',
									pagina: 'P. 246',
									linkUrl: 'https://www.youtube.com/watch?v=9nBDDfs7Nqw',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Eu me remexo muito',
									materia: 'Ciências Naturais',
									caderno: 'Cad. 1',
									ano_ensino: '1º Ano',
									pagina: 'P. 256 e 257',
									linkUrl: 'https://www.youtube.com/watch?v=2HRorv8WJAo',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Lobo Mau',
									materia: 'Língua Portuguesa',
									caderno: 'Cad. 1',
									ano_ensino: '2º Ano',
									pagina: 'P. 41',
									linkUrl: 'https://www.youtube.com/watch?v=IvcMmchaKAQ',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'O caderno',
									materia: 'Geografia',
									caderno: 'Cad. 1',
									ano_ensino: '2º Ano',
									pagina: 'P. 159',
									linkUrl: 'https://www.youtube.com/watch?v=y-ZaQkPnf4k',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Aquarela',
									materia: 'Geografia',
									caderno: 'Cad. 1',
									ano_ensino: '2º Ano',
									pagina: 'P. 161',
									linkUrl: 'https://www.youtube.com/watch?v=PT3azbKHJZU',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Corpo Humano',
									materia: 'Ciências',
									caderno: 'Cad. 1',
									ano_ensino: '2º Ano',
									pagina: 'P. 242',
									linkUrl: 'https://www.youtube.com/watch?v=GUHVPEBVxbk',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Um Índio',
									materia: 'Geografia',
									caderno: 'Cad. 4',
									ano_ensino: '4º Ano',
									pagina: 'P. 171',
									linkUrl: 'https://www.youtube.com/watch?v=GZFIhBfMj_4',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Eu nasci há 10 mil anos Atrás',
									materia: 'Geografia',
									caderno: 'Cad. 4',
									ano_ensino: '4º Ano',
									pagina: 'P. 178 e 179',
									linkUrl: 'https://www.youtube.com/watch?v=lzfhG7KZmj4',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'O cio da terra',
									materia: 'Ciências',
									caderno: 'Cad. 4',
									ano_ensino: '4º Ano',
									pagina: 'P. 281',
									linkUrl: 'https://www.youtube.com/watch?v=sB2uIJBzzsU',
									bundle: 'F_fundamental',
									segment: '1',
								},
							]
						},
						{
							name: '2º Bimestre',
							otherName: '',
							permission: 'segmento-infantil',
							books: [
								{
									name: '1, 2, Feijão com Arroz',
									materia: 'Língua Portuguesa',
									caderno: 'Cad. 2',
									ano_ensino: '1º Ano',
									pagina: 'P. 22',
									linkUrl: 'https://www.youtube.com/watch?v=te2ovhBOIEs',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Jacaré',
									materia: 'Língua Portuguesa',
									caderno: 'Cad. 2',
									ano_ensino: '1º Ano',
									pagina: 'P. 40',
									linkUrl: 'https://www.youtube.com/watch?v=y8SOSALxuWo',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Meu limão, meu limoeiro',
									materia: 'Língua Portuguesa',
									caderno: 'Cad. 2',
									ano_ensino: '1º Ano',
									pagina: 'P. 58',
									linkUrl: 'https://www.youtube.com/watch?v=IyuBBeABczQ',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Samba lê lê',
									materia: 'Língua Portuguesa',
									caderno: 'Cad. 2',
									ano_ensino: '1º Ano',
									pagina: 'P. 76',
									linkUrl: 'https://www.youtube.com/watch?v=21q78hGeNz8',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Dias da semana',
									materia: 'História',
									caderno: 'Cad. 2',
									ano_ensino: '1º Ano',
									pagina: 'P. 111',
									linkUrl: 'https://www.youtube.com/watch?v=kvSgHhcaTw0',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Vai e vem das Estações',
									materia: 'História',
									caderno: 'Cad. 2',
									ano_ensino: '1º Ano',
									pagina: 'P. 122',
									linkUrl: 'https://www.youtube.com/watch?v=jlNoF8GEGWc',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'O Cravo e a Rosa',
									materia: 'Ciências',
									caderno: 'Cad. 2',
									ano_ensino: '1º Ano',
									pagina: 'P. 256',
									linkUrl: 'https://www.youtube.com/watch?v=MvKpsmFTZ0Q',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'As Abelhas',
									materia: 'Ciências',
									caderno: 'Cad. 2',
									ano_ensino: '1º Ano',
									pagina: 'P. 257',
									linkUrl: 'https://www.youtube.com/watch?v=LcCw7MRdoPY',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Sopa',
									materia: 'Ciências',
									caderno: 'Cad. 2',
									ano_ensino: '1º Ano',
									pagina: 'P. 262',
									linkUrl: 'https://www.youtube.com/watch?v=LwX6FNc0NZE',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'A dança dos bichos',
									materia: 'Ciências',
									caderno: 'Cad. 2',
									ano_ensino: '1º Ano',
									pagina: 'P. 266',
									linkUrl: 'https://www.youtube.com/watch?v=YRLPwx_OUTg',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Somos Amigos',
									materia: 'História',
									caderno: 'Cad. 2',
									ano_ensino: '2º Ano',
									pagina: 'P. 126',
									linkUrl: 'https://www.youtube.com/watch?v=MOhFNDF6Ek4',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Se essa rua fosse minha',
									materia: 'Língua Portuguesa',
									caderno: 'Cad. 2',
									ano_ensino: '3º Ano',
									pagina: 'P. 28',
									linkUrl: 'https://www.youtube.com/watch?v=IuZf_xTt_JU',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Lindo balão azul',
									materia: 'Geografia',
									caderno: 'Cad. 2',
									ano_ensino: '3º Ano',
									pagina: 'P. 124',
									linkUrl: 'https://www.youtube.com/watch?v=XNDziHRb2Q0',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Aquarela do Brasil',
									materia: 'História',
									caderno: 'Cad. 2',
									ano_ensino: '4º Ano',
									pagina: 'P. 132 e 133',
									linkUrl: 'https://www.youtube.com/watch?v=r3Zjp1AO9lI',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Máscara Negra',
									materia: 'História',
									caderno: 'Cad. 2',
									ano_ensino: '4º Ano',
									pagina: 'P. 153',
									linkUrl: 'https://www.youtube.com/watch?v=0iWTtISXmAU',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Não deixe o samba morrer',
									materia: 'História',
									caderno: 'Cad. 2',
									ano_ensino: '4º Ano',
									pagina: 'P. 153',
									linkUrl: 'https://www.youtube.com/watch?v=PfXAKjKyAE0',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Canção do Exército',
									materia: 'História',
									caderno: 'Cad. 2',
									ano_ensino: '5º Ano',
									pagina: 'P. 59',
									linkUrl: 'https://www.youtube.com/watch?v=wzjrNJL0aBs',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Cisne Branco',
									materia: 'História',
									caderno: 'Cad. 2',
									ano_ensino: '5º Ano',
									pagina: 'P. 59',
									linkUrl: 'https://www.youtube.com/watch?v=bmvw8oe95o8H',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Era um garoto que como eu amava os Beatles e os Rolling Stones',
									materia: 'História',
									caderno: 'Cad. 2',
									ano_ensino: '5º Ano',
									pagina: 'P. 76',
									linkUrl: 'https://www.youtube.com/watch?v=GimLAyMbjLI',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Garota de Ipanema',
									materia: 'História',
									caderno: 'Cad. 2',
									ano_ensino: '5º Ano',
									pagina: 'P. 83',
									linkUrl: 'https://www.youtube.com/watch?v=WuenyQ4NCQE',
									bundle: 'F_fundamental',
									segment: '1',
								},
							]
						},
						{
							name: '3º Bimestre',
							otherName: '',
							permission: 'segmento-infantil',
							books: [
								{
									name: 'Quem quer pão?',
									materia: 'Língua Portuguesa',
									caderno: 'Cad. 3',
									ano_ensino: '1º Ano',
									pagina: 'P. 12',
									linkUrl: 'https://www.youtube.com/watch?v=ZJlJBuSsGi8',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Conheça os Flintstones',
									materia: 'História',
									caderno: 'Cad. 3',
									ano_ensino: '1º Ano',
									pagina: 'P. 110',
									linkUrl: 'https://www.youtube.com/watch?v=DAgeibKk0f0',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Alecrim Dourado',
									materia: 'Língua Portuguesa',
									caderno: 'Cad. 3',
									ano_ensino: '2º Ano',
									pagina: 'P. 12',
									linkUrl: 'https://www.youtube.com/watch?v=NAL4isDM4D0',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Jardim da Celeste',
									materia: 'Língua Portuguesa',
									caderno: 'Cad. 3',
									ano_ensino: '2º Ano',
									pagina: 'P. 12',
									linkUrl: 'https://www.youtube.com/watch?v=-do4uPn_9J4',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Hoje é domingo',
									materia: 'Língua Portuguesa',
									caderno: 'Cad. 3',
									ano_ensino: '2º Ano',
									pagina: 'P. 26',
									linkUrl: 'https://www.youtube.com/watch?v=AUbY_Xuu2Rk',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Fui a Espanha',
									materia: 'Língua Portuguesa',
									caderno: 'Cad. 3',
									ano_ensino: '2º Ano',
									pagina: 'P. 35',
									linkUrl: 'https://www.youtube.com/watch?v=hZz6Bp2RC5s',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Tem francesa no morro',
									materia: 'Língua Portuguesa',
									caderno: 'Cad. 3',
									ano_ensino: '2º Ano',
									pagina: 'P. 52',
									linkUrl: 'https://www.youtube.com/watch?v=IoqwaFIkA1o',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Samba na areia',
									materia: 'Língua Portuguesa',
									caderno: 'Cad. 3',
									ano_ensino: '2º Ano',
									pagina: 'P. 53',
									linkUrl: 'https://www.youtube.com/watch?v=9U0B-sqA_wM',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Ô Abre Alas',
									materia: 'Língua Portuguesa',
									caderno: 'Cad. 3',
									ano_ensino: '2º Ano',
									pagina: 'P. 55',
									linkUrl: 'https://www.youtube.com/watch?v=m_vaRKqCDYM',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Superfantástico',
									materia: 'História',
									caderno: 'Cad. 3',
									ano_ensino: '2º Ano',
									pagina: 'P. 81',
									linkUrl: 'https://www.youtube.com/watch?v=Pia8EBfzhF8',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Sobradinho',
									materia: 'Geografia',
									caderno: 'Cad. 3',
									ano_ensino: '4º Ano',
									pagina: 'P. 134',
									linkUrl: 'https://www.youtube.com/watch?v=EjVbTP7v9nY',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Arrastão',
									materia: 'História',
									caderno: 'Cad. 3',
									ano_ensino: '5º Ano',
									pagina: 'P. 72',
									linkUrl: 'https://www.youtube.com/watch?v=pySellcmkso',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Disparada',
									materia: 'História',
									caderno: 'Cad. 3',
									ano_ensino: '5º Ano',
									pagina: 'P. 72 e 73',
									linkUrl: 'https://www.youtube.com/watch?v=F4pOm8hRUyo',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Pra não dizer que não das flores',
									materia: 'História',
									caderno: 'Cad. 3',
									ano_ensino: '5º Ano',
									pagina: 'P. 78',
									linkUrl: 'https://www.youtube.com/watch?v=KdvsXn8oVPY',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: '"Cálice" (Cale-se)',
									materia: 'História',
									caderno: 'Cad. 3',
									ano_ensino: '5º Ano',
									pagina: 'P. 79',
									linkUrl: 'https://www.youtube.com/watch?v=9y2xB90A0CY',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Apesar de Você',
									materia: 'História',
									caderno: 'Cad. 3',
									ano_ensino: '5º Ano',
									pagina: 'P. 79',
									linkUrl: 'https://www.youtube.com/watch?v=bGAJlOwUgHY',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Eu te amo, Meu Brasil',
									materia: 'História',
									caderno: 'Cad. 3',
									ano_ensino: '5º Ano',
									pagina: 'P. 80',
									linkUrl: 'https://www.youtube.com/watch?v=ohgwcaj-XQc',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Pra frente Brasil',
									materia: 'História',
									caderno: 'Cad. 3',
									ano_ensino: '5º Ano',
									pagina: 'P. 97',
									linkUrl: 'https://www.youtube.com/watch?v=f4gaBRxd_TY',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Você também é responsável',
									materia: 'História',
									caderno: 'Cad. 3',
									ano_ensino: '5º Ano',
									pagina: 'P. 99',
									linkUrl: 'https://www.youtube.com/watch?v=G6kwbZIHZmA',
									bundle: 'F_fundamental',
									segment: '1',
								},
							]
						},
						{
							name: '4º Bimestre',
							otherName: '',
							permission: 'segmento-infantil',
							books: [
								{
									name: 'O Pescoço da Girafa',
									materia: 'Língua Portuguesa',
									caderno: 'Cad. 4',
									ano_ensino: '1º Ano',
									pagina: 'P. 18',
									linkUrl: 'https://www.youtube.com/watch?v=zZ6j-8jLDVc',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Marcha Soldado',
									materia: 'Língua Portuguesa',
									caderno: 'Cad. 4',
									ano_ensino: '1º Ano',
									pagina: 'P. 66',
									linkUrl: 'https://www.youtube.com/watch?v=yJScpeUP-cY',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Brincando de Índio',
									materia: 'Geografia',
									caderno: 'Cad. 4',
									ano_ensino: '1º Ano',
									pagina: 'P. 66',
									linkUrl: 'https://www.youtube.com/watch?v=VwoAIAHDh98',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Ratinho tomando banho',
									materia: 'Ciências',
									caderno: 'Cad. 4',
									ano_ensino: '2º Ano',
									pagina: 'P. 244',
									linkUrl: 'https://www.youtube.com/watch?v=IM7Ki0-Mh7M',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Oito anos',
									materia: 'Língua Portuguesa',
									caderno: 'Cad. 4',
									ano_ensino: '3º Ano',
									pagina: 'P. 8',
									linkUrl: 'watch?v=6GTAcoouQsI',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Fico assim sem você',
									materia: 'Língua Portuguesa',
									caderno: 'Cad. 4',
									ano_ensino: '3º Ano',
									pagina: 'P. 16',
									linkUrl: 'https://www.youtube.com/watch?v=iojYDSjKK00',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Avião',
									materia: 'Língua Portuguesa',
									caderno: 'Cad. 4',
									ano_ensino: '3º Ano',
									pagina: 'P. 19',
									linkUrl: 'watch?v=mfJnvTyQMPQ',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'O Macaquinho de pilha',
									materia: 'Língua Portuguesa',
									caderno: 'Cad. 4',
									ano_ensino: '3º Ano',
									pagina: 'P. 25',
									linkUrl: 'https://www.youtube.com/watch?v=f1GugwWh9Q0',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Rato',
									materia: 'Língua Portuguesa',
									caderno: 'Cad. 4',
									ano_ensino: '3º Ano',
									pagina: 'P. 29',
									linkUrl: 'https://www.youtube.com/watch?v=e5ADrw5YpHU',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Rosa de Hiroshima',
									materia: 'História',
									caderno: 'Cad. 4',
									ano_ensino: '3º Ano',
									pagina: 'P. 93',
									linkUrl: 'https://www.youtube.com/watch?v=BydC2fopTwo',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Asa Branca',
									materia: 'Geografia',
									caderno: 'Cad. 4',
									ano_ensino: '4º Ano',
									pagina: 'P. 123',
									linkUrl: 'https://www.youtube.com/watch?v=lehnxArU8To',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'O Xote das Meninas',
									materia: 'Geografia',
									caderno: 'Cad. 4',
									ano_ensino: '4º Ano',
									pagina: 'P. 124',
									linkUrl: 'https://www.youtube.com/watch?v=YI6Fy-fb9Ms',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Planeta Água',
									materia: 'Geografia',
									caderno: 'Cad. 4',
									ano_ensino: '4º Ano',
									pagina: 'P. 142',
									linkUrl: 'https://www.youtube.com/watch?v=oPwnAq2xMUg',
									bundle: 'F_fundamental',
									segment: '1',
								},
								{
									name: 'Coração Estudante',
									materia: 'História',
									caderno: 'Cad. 4',
									ano_ensino: '5º Ano',
									pagina: 'P. 66',
									linkUrl: 'https://www.youtube.com/watch?v=SCuu48me1hw',
									bundle: 'F_fundamental',
									segment: '1',
								},

							]
						},
					]
				},
			]
		};
	},


	created() {
		this.$emit('update-header', {
			title: this.pageTitle,
			subtitle: this.pageSubtitle
		});
	},

	computed: {

		permissions() {
			return this.$store.state.auth.userpermissions.permissions;
		},
		error503() {
			return (window.location.href = '/nao-autorizado');
		},

	},

	methods: {
		temPermissao(permissao) {
			return this.permissions.includes(permissao);
		},

		setActive(index) {
			this.activeIndex = index;
		},

		clearActive(index) {
			if (this.activeIndex === index) {
				this.activeIndex = [];
			}
		},

		toggleCollapse(type, idx) {
			if (!Array.isArray(this.collapsedStates[type])) {
				this.$set(this.collapsedStates, type, [])
			}

			this.collapsedStates[type].forEach((_, index) => {
				this.$set(this.collapsedStates[type], index, index === idx ? !this.collapsedStates[type][idx] : false)
			});
		},

		formatParam(param) {
			return param.replace(/\s+/g, '-');
		},
	}
};
</script>

<style lang="scss" scoped>
.main {
	margin-top: 30px;
}

.card_sistemacpv {
	border-radius: 8px;
	color: #3A1C53;
}

.btn_sistemacpv {
	display: inline-flex;
	min-width: auto;
	min-height: auto;

	margin: 20px auto 0;
	padding: 8px 16px;

	gap: 6px;

	background-color: #e98b24;
	border: 1px solid #e98b24;
	border-radius: 5px;

	display: flex;
	align-items: center;

	font-size: 16px;
	font-weight: 500;
	line-height: 22px;
	letter-spacing: auto;

	color: #ffffff;

	.icon {
		width: 18px;
		height: 18px;

		display: flex;
		align-items: center;
	}

	&:hover {
		background-color: #d27d20;
		transition: all 0.3s ease-in-out;
		border: 1px solid #d27d20;
		color: #fdf3e9;
	}
}
</style>